import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/style/public.css'
import Appointment from '@/components/Appointment';

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.component('appointment', Appointment);

new Vue({
    watch: {
        informationArticle: {
            deep: true,
            handler: function () {
                sessionStorage.setItem('informationArticle', JSON.stringify(this.informationArticle))
            }
        },
        informationLabel: {
            deep: true,
            handler: function () {
                sessionStorage.setItem('informationLabel', JSON.stringify(this.informationLabel))
            }
        }

    },
    mounted() {
        if (sessionStorage.getItem('informationArticle'))
            this.$root.informationArticle = JSON.parse(sessionStorage.getItem('informationArticle'))
        if (sessionStorage.getItem('informationLabel'))
            this.$root.informationLabel = JSON.parse(sessionStorage.getItem('informationLabel'))
    },
    data() {
        return {
            informationLabel: {},
            informationArticle: {},
            reservationPopover: false
        }
    },
    router,
    store,
    render: h => h(App)
}).$mount('#app')
